import axios from 'axios';

const baseDomain = process.env.VUE_APP_BASE_URL;
// TODO set the domain dynamically depending on the site with this form has been activated
const baseURL = `${baseDomain}/api/v1`;


export default axios.create({
  baseURL,
});
